import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex justify-center items-center flex-col" }
const _hoisted_2 = { class: "modal-header w-full flex flex-shrink-0 border-b border-gray-200 rounded-t-md" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-md ml-2 text-black mt-1" }, "Cerrar", -1)
const _hoisted_4 = { class: "w-full h-full py-20 text-center" }
const _hoisted_5 = { class: "font-bold" }
const _hoisted_6 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_7 = { class: "flow flex-col w-full col-span-2" }
const _hoisted_8 = { class: "w-full flex flex-col max-w-xl mx-auto mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_sirit_modal = _resolveComponent("sirit-modal")!

  return ($setup.global.getConfirmDate() !== null && $setup.global.isFree() && $setup.global.getDiffDate() !== 0 && _ctx.openModal)
    ? (_openBlock(), _createBlock(_component_sirit_modal, { key: 0 }, {
        modalContent: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeModal())),
                class: "cursor-pointer font-bold text-xl hover:text-sirit_blue-400"
              }, "x"),
              _hoisted_3
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(" Su plan "),
              _createElementVNode("span", _hoisted_5, _toDisplayString($setup.global.getUserPlanSession().name), 1),
              _createTextVNode(" " + _toDisplayString(90 > $setup.global.getDiffDate() ? 'está a punto de caducar' : 'ha caducado') + " ", 1),
              (90 - $setup.global.getDiffDate() > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(`Falta${90 - $setup.global.getDiffDate() > 1 ? 'n' : ''} ${ 90 - $setup.global.getDiffDate()} día${90 - $setup.global.getDiffDate() > 1 ? 's' : ''}`), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("button", {
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($props.type_ && $props.type_ !== '' ? $setup.closeModal() : $setup.goRoute_() )),
                  type: "submit",
                  class: _normalizeClass(["w-full text-white py-3 px-6 mb-20 rounded-md font-bold", `bg-${$setup.colors.primary}-500 hover:bg-${$setup.colors.primary}-600`])
                }, "Pasar a otro plan", 2)
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}